module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a0cb5aeb52541d110a10381eb6c05894.png";